import PropTypes from 'prop-types';

import Checkbox from '#globalComponents/Checkbox/Checkbox';

/** Multi-select of fixed values (OR-combined), each optionally with its row count. */
const EnumFilterControl = ({ heading, paramKey, options, value = [], counts, onChange }) => {
	const toggle = (optionValue) => {
		const next = value.includes(optionValue) ? value.filter((v) => v !== optionValue) : [...value, optionValue];
		onChange({ [paramKey]: next.length > 0 ? next : undefined });
	};

	return (
		<div>
			{heading && <span className="block text-xs text-bgBase-800 mb-1.5">{heading}</span>}
			<div className="space-y-1">
				{options.map((option) => (
					<Checkbox
						key={option.value}
						id={`hf-${paramKey}-${option.value}`}
						checked={value.includes(option.value)}
						onChange={() => toggle(option.value)}
						label={
							counts?.[option.value] === undefined
								? option.label
								: `${option.label} (${counts[option.value].toLocaleString('de-DE')})`
						}
					/>
				))}
			</div>
		</div>
	);
};

EnumFilterControl.propTypes = {
	heading: PropTypes.string,
	paramKey: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired }),
	).isRequired,
	value: PropTypes.arrayOf(PropTypes.string),
	/** Row count per option value, shown next to the label. */
	counts: PropTypes.objectOf(PropTypes.number),
	onChange: PropTypes.func.isRequired,
};

export default EnumFilterControl;
